import { useContext, useEffect, useState, useRef } from "react";
import useApiPrivate from "../../../global/utils/hooks/useApiPrivate";
import { useSearchParams } from "react-router-dom";
import { UserContext } from "../../../global/globalContext/context";
import PaginationComponent from "../../../global/Components/Pagination/PaginationComponent";
import { Row, Col, Spinner } from "reactstrap";
import Breadcrumbs from "../../../global/Components/Breadcrumb/Breadcrumb";
import { showMsg } from "../../../global/langs/langs";
import styles from './MyOrders.module.scss';
import OrderCard from "../../../global/Components/Items/orderCard/OrderCard";
import { Toast } from 'primereact/toast';

const ORDERS_URL = 'api/v1/orders';

export default function MyOrders() {
  const apiPrivate = useApiPrivate();
  // const[searchParams, setSearchParams] = useSearchParams();
  const {lang} = useContext(UserContext);
  const toast = useRef(null);

  const [orders, setOrders] = useState([]);
  const [metaData, setMetaData] = useState();
  const [currentPage, setCurrentPage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const callOrders = async () => {
    setIsLoading(true);

    try {
      const response = await apiPrivate.get(ORDERS_URL,{
        params:{
          page:currentPage && currentPage,
        }
      });
      setOrders(response.data.data);
      setMetaData(response.data.meta);
      setCurrentPage(response.data.meta?.current_page);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      } 
      setIsLoading(false);
    }
  }

  useEffect(() => {
    callOrders();
  },[]);

  useEffect(() => {
    // currentPage &&
    //   searchParams.set('page', currentPage);
    //   setSearchParams(searchParams);
      callOrders();
  },[currentPage]);
  
  return (
    <div>
      <Toast ref={toast} position="top-center" />

      <Row>
        <Col sm={8} md={8}>
          <Breadcrumbs />
        </Col>
        <Col sm={4} md={4}>
          <div className={`text-end fsSmall`}>
            {
            metaData ? (
              <>
                {metaData.total}
                <span>
                  {' '}{showMsg('results', lang)}
                </span>
              </>
            ) : (
              <span>
                {showMsg('no_results', lang)}
              </span>
            )
            }
          </div>
        </Col>
      </Row>
      {
        isLoading 
          ? (
            <>
              <Spinner color='primary' className='mx-auto'>
                Loading...
              </Spinner>
            </>
          ) 
          : (
            orders.length > 0 
              ? (
                <>
                  <Row>
                  { 
                    orders.map((order) => (
                      <Col key={order.id} xs={12} sm={6} md={6} xxl={6}>
                        <OrderCard order={order} />
                      </Col>                 
                    ))
                  }
                  </Row>
                </>
              ) 
              : (
                <p className="fw-bold py-4">
                  {showMsg('no_products_to_display', lang)}
                </p>
              )
          )
      }
      {
        metaData &&
          metaData.last_page > 1 
            ? (
              <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage}  metaData={metaData}/>
            ) 
            : ('')
      }            
    </div>

  )
}
